import type {
  AutoFollowFailedFansResponse,
  AutoFollowFan,
  AutoFollowFollowedFansResponse,
  AutoFollowResponses,
} from './types'

export function isFollowedResult(
  response: AutoFollowResponses,
): response is AutoFollowFollowedFansResponse {
  return (
    Array.isArray(response.fans) &&
    response.fans.every((fan: AutoFollowFan) => 'followedAt' in fan)
  )
}

export function isFailedResult(
  response: AutoFollowResponses,
): response is AutoFollowFailedFansResponse {
  return (
    Array.isArray(response.fans) &&
    response.fans.every((fan: AutoFollowFan) => 'failedAt' in fan)
  )
}
